import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import * as Sentry from "@sentry/react";

import Box from "@material-ui/core/Box";

import Grid from "@material-ui/core/Grid";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";

import Chart from "react-google-charts";
import { useHistory } from "react-router-dom";
import { iconsDict } from "../../assets/icons/iconsDict.js";

import { HiCurrencyRupee } from "react-icons/hi";
import BTC from "../../assets/svgs/bitcoin-btc-logo-01.svg";
import Icon from "../../fontIcons/icon";
import { CoinContext } from "../../contexts/CoinContext";
import { useSelector } from "react-redux";
import { REACT_APP_PROD_URL } from "../../services/configs";
import loaderGif from "../../assets/img/loader.gif";
import useSWR from "swr";
import fetcher from "../../api/swr_fetcher.js";
import useResizer from "../../services/useResizer.js";
import PortfolioCard from "../../components/PortfolioCard/index.js";
import { keyBy } from "lodash";
import { useQuery } from "react-query";
export default function MyPortfolio() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();
  const isMobile = useResizer();
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);

  const { data: balancesData, error: balancesError } = useSWR(
    `/v1/balances`,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );
  const [coinObj, setCoinObj] = useState();
  const [allBalances, setAllBalances] = useState(null);
  const [orderedBalances, setOrderedBalances] = useState(null);
  const [portFolioValue, setPortfolioValue] = useState(0);
  const [donutData, setDonutData] = useState(null);
  // const [hoverIcon, setHoverIcon] = React.useState(false);
  const prices = useSelector((state) => state.priceReducer.PRICES);

  const darkMode = useSelector((state) => state.trading.DARK_MODE);

  const { bannedTimeout } = useContext(CoinContext);
  const coinConfig = useQuery(
    ["coinConfig"],
    () => fetcher("/v1/coinConfig").then((res) => res),
    {
      onSuccess: (data) => {
        let coinObj = keyBy(data, "coinId");
        setCoinObj(coinObj);
      },
    }
  );
  useEffect(() => {
    if (balancesData) generateBalancesData(balancesData);
  }, [balancesData]);

  function generateBalancesData(data) {
    var cleanData = data.filter(
      (ele) =>
        Number(ele.availableBalance) > 0 ||
        Number(ele.inOrderBalance) > 0 ||
        Number(ele.inVaultBalance) > 0
    );
    setAllBalances(cleanData);
  }

  useEffect(() => {
    if (balancesError?.status === 401) {
      bannedTimeout("timeout");
    } else if (balancesError?.status === 403) {
      bannedTimeout("banned");
    }
  }, [balancesError]);

  useEffect(() => {
    if (prices && allBalances) {
      if (orderedBalances === null) {
        if (allBalances.length !== 0) {
          let valueA;
          let valueB;
          // console.log("Yay prices have loaded, now ordering accordingly");
          // console.log("Before sorting: ", allBalances);
          allBalances.sort(function (a, b) {
            if (!prices[`${a.coinId}INR`]) {
              valueA = 0;
            } else {
              valueA =
                prices[`${a.coinId}INR`]["b"] *
                (Number(a.availableBalance) + Number(a.inOrderBalance));
            }
            if (!prices[`${b.coinId}INR`]) {
              valueB = 0;
            } else {
              valueB =
                prices[`${b.coinId}INR`]["b"] *
                (Number(b.availableBalance) + Number(b.inOrderBalance));
            }
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          });
          // console.log("After sorting: ", allBalances);
          setOrderedBalances(allBalances);
        } else {
          setOrderedBalances([]);
        }
      }
    }
  }, [prices]);

  useEffect(() => {
    if (prices && allBalances) {
      if (allBalances.length !== 0) {
        var total = 0;
        let arr = [["Coin", "balance"]];
        allBalances.map((item) => {
          if (prices[`${item.coinId}INR`]) {
            var inrVal =
              Number(prices[`${item.coinId}INR`]["b"]) *
              (Number(item.availableBalance) +
                Number(item.inOrderBalance) +
                Number(item.inVaultBalance));
            total = total + inrVal;

            arr.push([item.coinId, inrVal]);
          } else if (item.coinId === "INR") {
            // console.log(`${total} + ${item.availableBalance} = ${Number(total) + Number(item.availableBalance)}`)
            total =
              Number(total) +
              Number(item.availableBalance) +
              Number(item.inOrderBalance) +
              Number(item.inVaultBalance);
            arr.push([
              item.coinId,
              Number(item.availableBalance) +
                Number(item.inOrderBalance) +
                Number(item.inVaultBalance),
            ]);
          }
        });
        setPortfolioValue(Number(total));
        setDonutData(arr);
        // console.log(arr)
      }
    }
  }, [prices]);

  // doesn't work, prices load too late
  // useEffect(() => {
  //   if (prices && allBalances) {
  //     let arr = [["Coin", "balance"]]
  //     allBalances.map((item) => {
  //       if (prices[`${item.coinId}INR`]) {
  //         var inrVal = Number(prices[`${item.coinId}INR`]["a"]) * Number(item.availableBalance)
  //         arr.push([item.coinId, inrVal])
  //       } else if (item.coinId === "INR") {
  //         arr.push([item.coinId, Number(item.availableBalance)])
  //       }
  //     });
  //     setDonutData(arr)
  //     console.log(arr)
  //   }
  // }, [])

  // const donutData = [
  //   ["Task", "Hours per Day"],
  //   ["Work", 20],
  //   ["Eat", 20],
  //   ["Commute", 20],
  //   ["Watch TV", 20],
  //   ["Sleep", 20], // CSS-style declaration
  // ];

  const donutOptions = {
    // title: "Assets",
    is3D: false,
    backgroundColor: "transparent",
    sliceVisibilityThreshold: 0.0001,
    pieSliceBorderColor: theme.palette.type === "dark" ? "#151828" : "#ffffff",
    pieSliceText: "value",
    pieHole: 0.3,
    colors: [
      "#F1A54A",
      "#F14AAE",
      "#51F3F3",
      "#FCD75B",
      "#FF695E",
      "#51F39C",
      "#8F51F3",
      "#5B92FC",
      "#51F39C",
    ],
    "backgroundColor.stroke": "#151828",
    "backgroundColor.strokeWidth": "5px",
    // legend: "none",
    legend: {
      position: "labeled",
      textStyle: {
        color: theme.palette.type === "dark" ? "white" : "black",
        fontWeight: "bold",
      },
    },
    chartArea: { left: 0, top: 40, width: "100%", height: "80%" },
  };

  return (
    <>
      <Grid container className={classes.root}>
        <Grid
          item
          xs={2}
          style={{
            marginTop: "30px",
            marginLeft: "20px",
            marginRight: "30px",
          }}
          className="mt-0 md:mt-8 "
        >
          <Box>
            <p
              className="md:text-[25px] w-max leading-9 text-base"
              style={{ margin: 0, color: "#929399" }}
            >
              Portfolio Value
            </p>
            {orderedBalances && allBalances ? (
              <p style={{ fontSize: "25px", whiteSpace: "nowrap" }}>
                &#x20B9;{" "}
                {parseFloat(portFolioValue.toFixed(2)).toLocaleString()}
              </p>
            ) : (
              <p style={{ fontSize: "25px" }}>Loading...</p>
            )}
          </Box>
        </Grid>

        {/*<LineChart />*/}

        {allBalances ? (
          allBalances.length !== 0 ? (
            <Grid item xs={12} md={4}>
              {donutData ? (
                <div className={classes.chartStyle}>
                  <Chart
                    chartType="PieChart"
                    width="100%"
                    height="300px"
                    data={donutData}
                    options={donutOptions}
                  />
                  {donutData.length <= 2 ? null : (
                    <div className={classes.label}>
                      <p style={{ margin: 0 }}>{allBalances.length}</p>
                      <p style={{ margin: 0 }}>Assets</p>
                    </div>
                  )}
                </div>
              ) : null}
            </Grid>
          ) : null
        ) : null}

        <Grid item xs={12} style={{ marginTop: "15px" }}>
          <div className={classes.tableRoot}>
            {isMobile ? (
              orderedBalances?.map((row) => (
                <div
                  style={{
                    borderBottom: !darkMode
                      ? "1px solid #999"
                      : "1px solid #000",
                  }}
                >
                  <PortfolioCard
                    coinIcons={coinIcons[row.coinId]}
                    coin={row}
                    prices={prices}
                    coinObj={coinObj}
                  ></PortfolioCard>
                </div>
              ))
            ) : (
              <TableContainer component="div">
                <Table
                  className={`${classes.table} `}
                  aria-label="STOCKS TABLE"
                >
                  <TableHead>
                    <TableRow className={classes.tableHeadText}>
                      <TableCell
                        className={classes.tableHeading}
                        align="left"
                        colSpan={6}
                      >
                        CURRENT HOLDINGS
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead>
                    <TableRow className={classes.tableHeadText}>
                      <TableCell
                        className={classes.tableHeadText}
                        align="left"
                        style={{ paddingLeft: "25px" }}
                      >
                        ASSET
                      </TableCell>
                      <TableCell className={classes.tableHeadText} align="left">
                        AVAILABLE BALANCE
                      </TableCell>
                      <TableCell className={classes.tableHeadText} align="left">
                        IN ORDERS
                      </TableCell>
                      <TableCell
                        className={classes.tableHeadText}
                        align="left"
                        // onClick={orderList}
                      >
                        IN VAULT
                      </TableCell>
                      <TableCell className={classes.tableHeadText} align="left">
                        CURRENT SELL PRICE
                      </TableCell>
                      <TableCell
                        className={classes.tableHeadText}
                        align="left"
                        // onClick={orderList}
                      >
                        INR VALUE
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderedBalances
                      ? orderedBalances.map((row) => (
                          <TableRow
                            key={row.coinId}
                            className={classes.bodyRows}
                          >
                            <TableCell
                              style={{ paddingLeft: "25px", width: "350px" }}
                              align="left"
                              className={classes.indifferentCell}
                            >
                              {row.coinId === "INR" ? (
                                <div style={{ display: "flex" }}>
                                  <HiCurrencyRupee
                                    style={{ fontSize: "41px" }}
                                  />
                                  <div style={{ marginLeft: "5px" }}>
                                    <p
                                      style={{
                                        fontSize: "16px",
                                        marginTop: 0,
                                        marginLeft: "5px",
                                        marginBottom: 0,
                                      }}
                                    >
                                      Indian Rupee
                                    </p>
                                    <p
                                      style={{
                                        color: "#9fa1a0",
                                        marginBottom: 0,
                                        marginTop: 0,
                                        marginLeft: "5px",
                                      }}
                                    >
                                      INR
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                <div style={{ display: "flex" }}>
                                  <img
                                    src={coinIcons?.[row.coinId]?.activeIconUrl}
                                    height="auto"
                                    width={30}
                                    className="mr-2"
                                    alt={row.title}
                                  />
                                  <div style={{ marginLeft: "5px" }}>
                                    <p
                                      style={{
                                        fontSize: "16px",
                                        marginTop: 0,
                                        marginLeft: "5px",
                                        marginBottom: 0,
                                      }}
                                    >
                                      {coinIcons?.[row.coinId]?.["coinName"]}
                                    </p>
                                    <p
                                      style={{
                                        color: "#9fa1a0",
                                        marginBottom: 0,
                                        marginTop: 0,
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {row.coinId}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </TableCell>
                            <TableCell
                              className={classes.bodyTextStyles}
                              align="left"
                            >
                              {row.coinId === "INR"
                                ? Number(row.availableBalance).toFixed(2)
                                : Number(row.availableBalance)}
                            </TableCell>
                            <TableCell
                              className={classes.bodyTextStyles}
                              align="left"
                            >
                              {Number(row.inOrderBalance)}
                            </TableCell>{" "}
                            <TableCell
                              className={classes.bodyTextStyles}
                              align="left"
                            >
                              {Number(row.inVaultBalance)}
                            </TableCell>
                            <TableCell
                              className={classes.bodyTextStyles}
                              align="left"
                            >
                              {prices
                                ? prices[`${row.coinId}INR`]
                                  ? prices[`${row.coinId}INR`]["b"]
                                  : null
                                : null}
                            </TableCell>
                            <TableCell
                              className={classes.bodyTextStyles}
                              align="left"
                            >
                              {row.coinId === "INR"
                                ? (
                                    Number(row.availableBalance) +
                                    Number(row.inOrderBalance)
                                  ).toFixed(2)
                                : null}
                              {prices
                                ? prices[`${row.coinId}INR`]
                                  ? (
                                      prices[`${row.coinId}INR`]["b"] *
                                      (Number(row.availableBalance) +
                                        Number(row.inOrderBalance))
                                    ).toFixed(2)
                                  : null
                                : null}
                            </TableCell>
                          </TableRow>
                        ))
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </Grid>
        {/*
        <Grid item xs={12} md={6} className={classes.watch}>
          <WatchList />
        </Grid>

        <Grid item xs={12} md={5} style={{marginTop: '15px'}}>
          <ActivityTable />
        </Grid>
        */}
      </Grid>

      <Backdrop
        className={classes.backdrop}
        open={orderedBalances && allBalances ? false : true}
      >
        {/* <CircularProgress color="primary" /> */}
        <img src={loaderGif} alt="loading..." />
      </Backdrop>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "450px",
    },
    width: "95%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  watch: {
    marginTop: "15px",
    [theme.breakpoints.up("md")]: {
      marginRight: "15px",
    },
  },
  table: {
    backgroundColor: theme.palette.type === "dark" ? "#151828" : "white",
    color: theme.palette.text.primary,
    borderBottom: "none",
  },
  tableHeadText: {
    color: theme.palette.text.primary,
    opacity: 0.7,
    fontWeight: "bold",
    borderBottom:
      theme.palette.type === "dark" ? `1px solid #2D2F3E` : `1px solid #B1B1B1`,
  },
  bodyTextStyles: {
    color: theme.palette.text.primary,
    fontSize: "14px",
    borderBottom: "none",
  },
  centeredImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  indifferentCell: {
    borderBottom: "none",
  },
  tableHeading: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    fontSize: "1rem",
    borderBottom:
      theme.palette.type === "dark" ? `1px solid #2D2F3E` : `1px solid #B1B1B1`,
  },
  bodyRows: {
    borderBottom:
      theme.palette.type === "dark" ? `1px solid #2D2F3E` : `1px solid #B1B1B1`,
  },
  chartStyle: {
    position: "relative",
    margin: 0,
    // background: theme.palette.type === "dark" ? "#151828" : "#ffffff",
  },
  label: {
    position: "absolute",
    left: "50%",
    top: "53%",
    transform: "translate(-20px, -20px)",
  },
  iconColor: {
    "&:hover": {
      fill: "red",
      cursor: "pointer",
    },
    fill: "red !important",
  },
  tableRoot: {
    position: "relative",
    [theme.breakpoints.down("md")]: {
      "&:after": {
        content: "''",
        position: "absolute",
        zIndex: 1,
        top: "0",
        right: "0",
        bottom: "15px",
        pointerEvents: "none",

        width: "15%",
        // boxShadow: "inset 100px 100px 100px 0px rgba(0, 0, 0, 0.5);",
      },
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
